import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
import {
  getAuth, signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updatePassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword
} from "firebase/auth";
import {
  getDatabase,
  ref,
  set,
  push,
  get,
  update,
  increment,
  remove,
  onValue,
  query,
  orderByChild,
  equalTo
} from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyAeTuOuSkcfumf8e6y0sRBmt1ju3LdbFQE",
  authDomain: "prglovebox.firebaseapp.com",
  databaseURL: "https://prglovebox-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "prglovebox",
  storageBucket: "prglovebox.firebasestorage.app",
  messagingSenderId: "56125520266",
  appId: "1:56125520266:web:3aff579618027f2ebe3073"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
const auth = getAuth(app);
export { // Core
  app,
  auth,

  // Auth methods
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updatePassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword,

  // Database methods
  ref,
  set,
  push,
  get,
  update,
  increment,
  remove,
  onValue,
  query,
  orderByChild,
  equalTo
};
